
// Enum for filter operations (expanded for Foundry/Palantir support)
export enum FilterOperator {
    EQUALS = 'equals',            // $eq
    NOT_EQUALS = 'notEquals',     // $not/$ne
    GREATER_THAN = 'greaterThan', // $lt/$gt
    LESS_THAN = 'lessThan',
    GREATER_THAN_OR_EQUALS = 'greaterThanEqual',
    LESS_THAN_OR_EQUALS = 'lessThanEqual',
    CONTAINS = 'contains',
    STARTS_WITH = 'startsWith',
    IN = 'in',                    // $in
    IS_NULL = 'isNull',           // $isNull
    NOT = 'not',                  // $not
    AND = 'and',                  // $and
    OR = 'or',                    // $or
    CONTAINS_ANY_TERM = 'containsAnyTerm',           // $containsAnyTerm
    CONTAINS_ALL_TERMS = 'containsAllTerms',         // $containsAllTerms
    CONTAINS_ALL_TERMS_IN_ORDER = 'containsAllTermsInOrder', // $containsAllTermsInOrder
}

// Mapping for UI display symbols
export const operatorSymbols: Record<FilterOperator, string> = {
    [FilterOperator.EQUALS]: ':',
    [FilterOperator.NOT_EQUALS]: '≠',
    [FilterOperator.GREATER_THAN]: '>',
    [FilterOperator.LESS_THAN]: '<',
    [FilterOperator.GREATER_THAN_OR_EQUALS]: '≥',
    [FilterOperator.LESS_THAN_OR_EQUALS]: '≤',
    [FilterOperator.CONTAINS]: '∋',
    [FilterOperator.STARTS_WITH]: '⇾',
    [FilterOperator.IN]: '∈',
    [FilterOperator.IS_NULL]: '∅',
    [FilterOperator.NOT]: '¬',
    [FilterOperator.AND]: '∧',
    [FilterOperator.OR]: '∨',
    [FilterOperator.CONTAINS_ANY_TERM]: '∋∃',
    [FilterOperator.CONTAINS_ALL_TERMS]: '∋∀',
    [FilterOperator.CONTAINS_ALL_TERMS_IN_ORDER]: '∋→',
};
